export { default as Img200 } from './processed/200/SilentHillRevalations.jpg';
export { default as Img400 } from './processed/400/SilentHillRevalations.jpg';
export { default as Imgthumb } from './processed/thumb/SilentHillRevalations.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/SilentHillRevalations.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/SilentHillRevalations.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      201,
      4,
      4
    ],
    "_population": 257,
    "_hsl": [
      0,
      0.9609756097560974,
      0.4019607843137255
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      151,
      4,
      4
    ],
    "_population": 1878,
    "_hsl": [
      0,
      0.9483870967741934,
      0.303921568627451
    ]
  },
  "Muted": {
    "_rgb": [
      143,
      137,
      105
    ],
    "_population": 1208,
    "_hsl": [
      0.14035087719298242,
      0.15322580645161293,
      0.48627450980392156
    ]
  },
  "LightMuted": {
    "_rgb": [
      208,
      205,
      184
    ],
    "_population": 13,
    "_hsl": [
      0.1458333333333334,
      0.20338983050847456,
      0.7686274509803921
    ]
  },
  "DarkMuted": {
    "_rgb": [
      87,
      81,
      57
    ],
    "_population": 2646,
    "_hsl": [
      0.13333333333333328,
      0.20833333333333334,
      0.2823529411764706
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/SilentHillRevalations.js